import api from './api';
import { supabase } from '../lib/supabase';
import type { MetricsRange, MetricsResponse } from '../types/Metrics';

async function authHeaders(): Promise<Record<string, string>> {
  const headers: Record<string, string> = {};
  if (supabase) {
    const {
      data: { session },
    } = await supabase.auth.getSession();
    if (session?.access_token) {
      headers.Authorization = `Bearer ${session.access_token}`;
    }
  }
  return headers;
}

export async function fetchMetrics(range: MetricsRange) {
  const headers = await authHeaders();
  return api.get<MetricsResponse>('/admin/metrics', {
    params: { range },
    headers,
  });
}
